
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { LinkButton } from 'brand-guidelines/Buttons-styled-components';
import { BRAND_COLORS } from 'brand-guidelines/colors';
import { TYPOGRAPHY } from 'brand-guidelines/typography';
import { selectDataClinicCountry } from 'connect/selectors';
import { CheckoutStateHandler } from 'pages/checkout/connect/state-handlers';

import { MemberIdHelperModal } from './MemberIdHelperModal';

const MemberIdHelperButton = styled(LinkButton)`
  ${TYPOGRAPHY.CIRCULAR.bold}
  color: ${BRAND_COLORS.darkGreen};
`;

interface MemberIdHelperProps {
  insuranceProviderName?: string;
}
export const MemberIdHelper = ({ insuranceProviderName }: MemberIdHelperProps) => {
  const clinicCountry = useSelector(selectDataClinicCountry);
  const { patient } = useSelector(CheckoutStateHandler.selector);

  const [isMemberIDHelperVisible, setIsMemberIDHelperVisible] = useState<boolean>(false);

  const showMemberIdModal = () => setIsMemberIDHelperVisible(true);
  const hideMemberIdModal = () => setIsMemberIDHelperVisible(false);

  return (
    <>
      <MemberIdHelperButton onClick={showMemberIdModal}>
        Help me find it
      </MemberIdHelperButton>

      <MemberIdHelperModal
        onCancel={hideMemberIdModal}
        onOk={hideMemberIdModal}
        visible={isMemberIDHelperVisible}
        insuranceProvider={insuranceProviderName || ''}
        patient={patient}
        country={clinicCountry}
      />
    </>
  );
};
